<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="false"
      text-color="#444"
      active-text-color="#fff"
    >
      <sidebar-item :routes="role_routers"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'role_routers'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/components/Sidebar/index.vue